<div class="product-keyboard-root">
    <div
        class="product-keyboard-backdrop fixed"
        uppDataid="ticketproduct-keyboard-backdrop"
        tabindex="0"
        (click)="OnBackdrop($event)"
        (keydown.enter)="OnBackdrop($event)"
        (keydown.space)="OnBackdrop($event)"
    ></div>
    <div class="product-keyboard-panel">
        <div class="product-keyboard" uppDataid="ticketproduct-product-keyboard">
            <div class="product-keyboard__modes product-keyboard__modes--icons">
                <ion-button uppDataid="ticketproduct-keyboard-mode-qty" class="product-keyboard__mode"
                    expand="block"
                    color="primary"
                    [fill]="Field === 'amount' ? 'solid' : 'outline'"
                    [disabled]="!IsEnabled('amount')"
                    size="default"
                    (click)="OnAmount($event)"
                >
                    <div class="product-keyboard__mode-stack">
                        <ion-icon name="cart-outline"></ion-icon>
                        <span class="product-keyboard__mode-label">{{ tr('@ticket_keyboard_field_amount') }}</span>
                    </div>
                </ion-button>
                <ion-button uppDataid="ticketproduct-keyboard-mode-price" class="product-keyboard__mode"
                    expand="block"
                    color="primary"
                    [fill]="Field === 'price' ? 'solid' : 'outline'"
                    [disabled]="!IsEnabled('price')"
                    size="default"
                    (click)="OnPrice($event)"
                >
                    <div class="product-keyboard__mode-stack">
                        <ion-icon name="logo-euro"></ion-icon>
                        <span class="product-keyboard__mode-label">{{ tr('@ticket_keyboard_field_price') }}</span>
                    </div>
                </ion-button>
                <ion-button uppDataid="ticketproduct-keyboard-mode-percent" class="product-keyboard__mode"
                    expand="block"
                    color="primary"
                    [fill]="Field === 'percent' ? 'solid' : 'outline'"
                    [disabled]="!IsEnabled('percent')"
                    size="default"
                    (click)="OnPercent($event)"
                >
                    <div class="product-keyboard__mode-stack">
                        <span class="product-keyboard__mode-glyph">%</span>
                        <span class="product-keyboard__mode-label">{{ tr('@ticket_keyboard_field_percent') }}</span>
                    </div>
                </ion-button>
                <ion-button uppDataid="ticketproduct-keyboard-mode-invite" class="product-keyboard__mode"
                    expand="block"
                    color="primary"
                    [fill]="InviteTabActive ? 'solid' : 'outline'"
                    [disabled]="!IsEnabled('invite')"
                    size="default"
                    (click)="OnInvite($event)"
                >
                    <div class="product-keyboard__mode-stack">
                        <ion-icon [name]="ticketproduct?.IsInvite ? 'heart-dislike-outline' : 'heart-outline'"></ion-icon>
                        <span class="product-keyboard__mode-label">{{ tr('@ticket_keyboard_field_invite') }}</span>
                    </div>
                </ion-button>
            </div>
            <div class="product-keyboard__action-hint" *ngIf="ActionHintKey as actionHintKey">
                {{ tr(actionHintKey) }}
            </div>
            <div class="product-keyboard__row product-keyboard__display-row" [ngClass]="{ 'product-keyboard__display-row--disabled': NumpadDisabled }">
                <div class="product-keyboard__display" uppDataid="ticketproduct-keyboard-display">{{ Display }}</div>
            </div>
            <div class="product-keyboard__numpad-panel" [ngClass]="{ 'product-keyboard__numpad-panel--disabled': NumpadDisabled }">
                <div class="product-keyboard__row product-keyboard__numpad">
                    <ion-button uppDataid="ticketproduct-keyboard-7" class="product-keyboard__key"
                        fill="solid"
                        color="light"
                        [disabled]="NumpadDisabled"
                        (click)="OnDigit($event, '7')"
                    >7</ion-button>
                    <ion-button uppDataid="ticketproduct-keyboard-8" class="product-keyboard__key"
                        fill="solid"
                        color="light"
                        [disabled]="NumpadDisabled"
                        (click)="OnDigit($event, '8')"
                    >8</ion-button>
                    <ion-button uppDataid="ticketproduct-keyboard-9" class="product-keyboard__key"
                        fill="solid"
                        color="light"
                        [disabled]="NumpadDisabled"
                        (click)="OnDigit($event, '9')"
                    >9</ion-button>
                </div>
                <div class="product-keyboard__row product-keyboard__numpad">
                    <ion-button uppDataid="ticketproduct-keyboard-4" class="product-keyboard__key"
                        fill="solid"
                        color="light"
                        [disabled]="NumpadDisabled"
                        (click)="OnDigit($event, '4')"
                    >4</ion-button>
                    <ion-button uppDataid="ticketproduct-keyboard-5" class="product-keyboard__key"
                        fill="solid"
                        color="light"
                        [disabled]="NumpadDisabled"
                        (click)="OnDigit($event, '5')"
                    >5</ion-button>
                    <ion-button uppDataid="ticketproduct-keyboard-6" class="product-keyboard__key"
                        fill="solid"
                        color="light"
                        [disabled]="NumpadDisabled"
                        (click)="OnDigit($event, '6')"
                    >6</ion-button>
                </div>
                <div class="product-keyboard__row product-keyboard__numpad">
                    <ion-button uppDataid="ticketproduct-keyboard-1" class="product-keyboard__key"  
                        fill="solid"
                        color="light"
                        [disabled]="NumpadDisabled"
                        (click)="OnDigit($event, '1')"
                    >1</ion-button>
                    <ion-button uppDataid="ticketproduct-keyboard-2" class="product-keyboard__key"  
                        fill="solid"
                        color="light"
                        [disabled]="NumpadDisabled"
                        (click)="OnDigit($event, '2')"
                    >2</ion-button>
                    <ion-button uppDataid="ticketproduct-keyboard-3" class="product-keyboard__key"  
                        fill="solid"
                        color="light"
                        [disabled]="NumpadDisabled"
                        (click)="OnDigit($event, '3')"
                    >3</ion-button>
                </div>
                <div class="product-keyboard__row product-keyboard__numpad product-keyboard__numpad--bottom">
                    <ion-button uppDataid="ticketproduct-keyboard-0" class="product-keyboard__key"      
                        fill="solid"
                        color="light"
                        [disabled]="NumpadDisabled"
                        (click)="OnDigit($event, '0')"
                    >0</ion-button>
                    <ion-button
                        uppDataid="ticketproduct-keyboard-dot" class="product-keyboard__key product-keyboard__key--dot"
                        fill="solid"
                        color="light"
                        [disabled]="!ShowsDecimalKey || NumpadDisabled"
                        (click)="OnDigit($event, '.')"
                    >.</ion-button>
                    <ion-button uppDataid="ticketproduct-keyboard-clear" class="product-keyboard__key product-keyboard__key--clear"
                        fill="clear"
                        color="danger"
                        [disabled]="NumpadDisabled"
                        (click)="OnClearDisplay($event)"
                    >
                        <span class="product-keyboard__clear-letter">C</span>
                    </ion-button>
                </div>
            </div>
            <div class="product-keyboard__apply-bar product-keyboard__apply-bar--cart">
                <div class="product-keyboard__apply-cart">
                    <ion-icon *ngIf="ShowsApplyScope" uppDataid="ticketproduct-keyboard-delone"
                        class="product-keyboard__apply-icon product-keyboard__apply-icon--left"
                        color="primary"
                        name="remove-circle-outline"
                        [ngClass]="{ 'disabled': !CanDelStep }"
                        (click)="OnDelClick($event)"
                        (pointerdown)="OnDelPressed(true, $event)"
                        (pointerup)="OnDelPressed(false, $event)"
                        (pointercancel)="OnDelPressed(false, $event)"
                        (pointerleave)="OnDelPressed(false, $event)"
                    ></ion-icon>
                    <ion-button uppDataid="ticketproduct-keyboard-submit" class="product-keyboard__apply-btn"
                        expand="block"
                        color="primary"
                        fill="outline"
                        size="large"
                        [disabled]="!CanSubmit"
                        (click)="OnSubmit($event)"
                    >
                        {{ ShowsApplyScope ? tr('@ticket_product_keyboard_apply_to', [ApplyCount]) : tr('@ticket_product_keyboard_submit') }}
                    </ion-button>
                    <ion-icon *ngIf="ShowsApplyScope" uppDataid="ticketproduct-keyboard-addone"
                        class="product-keyboard__apply-icon product-keyboard__apply-icon--right"
                        color="primary"
                        name="add-circle-outline"
                        [ngClass]="{ 'disabled': !CanAddStep }"
                        (click)="OnAddClick($event)"
                        (pointerdown)="OnAddPressed(true, $event)"
                        (pointerup)="OnAddPressed(false, $event)"
                        (pointercancel)="OnAddPressed(false, $event)"
                        (pointerleave)="OnAddPressed(false, $event)"
                    ></ion-icon>
                </div>
                <ion-button uppDataid="ticketproduct-keyboard-cancel" class="product-keyboard__cancel-btn"
                    expand="block"
                    fill="clear"
                    color="primary"
                    (click)="OnCancel($event)"
                >
                    {{ tr('@ticket_product_add_cancel') }}
                </ion-button>
            </div>
        </div>
    </div>
</div>
